import React from 'react'
import {AuthContext} from '../../lib/AuthContext';
import ParentComponent from '../../lib/ParentComponent';
import firebase, {auth} from '../../lib/firebase';
import Utils from '../../Utils';
import ar from '../../locale';
import Loading from '../../lib/Loading';
import {title, deleteUrl} from '../../constants';
import { Player } from 'video-react';

export default class MyHobbyEdit extends ParentComponent {
    
    static contextType = AuthContext;
    
    constructor(props, context) {
        super(props, context);
        this.state = {
            user: context.user,
            loading: false,
            video: {},
            comments: [],
            token: null,
            deleting: {},
        }
        this.videoRef = firebase.database().ref('hobbyvideos/'+this.props.match.params.key);
    }

    componentDidMount() {
        super.componentDidMount();
        document.title = title + ' - ' +ar.womens_ball;
        auth.currentUser.getIdToken().then(token => {
            this.state.token = token;
            this.updateState();
        });
        this.videoRef.on('value', snapshot => {
            if (!snapshot.exists()) {
                this.props.history.replace('/404');
            } else {
                this.state.video = snapshot.val();
                this.updateState();
            }
            this.commentsRef = firebase.database().ref('comments/hobbyvideos/'+this.props.match.params.key);
            this.commentsRef.on('value', res => {
                this.state.comments = Utils.convertToArrayWithOrderKeyDesc(res.val(), 'on');
                this.updateState();
            });
        });
        window.Tablesaw.init(this.$('#sawtable'));
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.videoRef.off('value');
        if (this.commentsRef) {
            this.commentsRef.off('value');
        }
    }

    showLoading = show => {
        this.state.loading = show;
        this.updateState();
    };

    updateState = () => {
        this.setState(prev => {
            return {...prev}
        })
    };

    onCheck = (key, e) => {
        let value = e.target.checked;
        if(key === 'featured') {
            if(value) {
                this.reviewed.checked = true;
            }
        } else {
            if(!value) {
                this.featured.checked = false;
            }
        }
    };

    updateVideoDetails = () => {
        let featured = this.featured.checked;
        let reviewed = this.reviewed.checked;
        let country = this.country.value;
        let age = this.age.value;
        if (country && age) {
            this.showLoading(true);
            this.videoRef.update({
                featured: featured,
                reviewed: reviewed,
                country: country,
                age: age,
            })
            .then(() => {
                this.showLoading(false);
                this.showSuccess(ar.operation_successful);
            })
            .catch(error=>{
                this.showLoading(false);
                this.showError(error.message);
            });
        } else {
            this.showError(ar.please_fill_all_options);
        }
    };

    deleteCommentConfirmation = comment => {
         this.confirm(null,this.deleteComment.bind(this,comment));
    };

    deleteComment = comment => {
        this.state.deleting[comment.key] = true;
        this.updateState();
        fetch(deleteUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this.state.token,
            },
            body: JSON.stringify({
                    path: 'comments/hobbyvideos/'+ this.state.video.key +'/'+comment.key,
                }),
            })
            .then(() => this.updateCommentCount())
            .then(() => {
                this.updateState();
            })
        .catch(error => {
           this.state.deleting[comment.key] = false;
           this.showError(error.message);
        });
    };

    updateCommentCount = () => {
        this.videoRef.child('comments').transaction(comments => {
            comments = comments || 0;
            if (comments > 0 ) {
                --comments;
            }
            return comments;
        });
    };

    renderComment = comment => {
        return (
            <tr key={comment.key}>
                <td>
                    {comment.photoUrl && (
                        <img src={comment.photoUrl} alt="avatar" className="avatarc rounded-circle" width="30" height="30" />
                    )}
                </td>
                <td className="title">
                    {comment.name}
                </td>
                <td>{comment.text}</td>
                <td>
                    {!this.state.deleting[comment.key] && (
                        <i className="fa fa-trash text-danger cursor-pointer" title={ar.delete} onClick={this.deleteCommentConfirmation.bind(this,comment)}></i>
                    )}
                    {this.state.deleting[comment.key] && (
                        <div className="d-inline-block spinner-border spinner-border-sm text-danger" role="status"></div>
                    )}
                </td>
            </tr>
        )
    };

    render() {
        let {loading,video, comments}  = this.state;
        return(
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card no-toolbar border-0">
                                <div className="card-body">
                                    <h2 className="card-title">{ar.my_hobby}</h2>
                                    <h5 className="card-subtitle mb-0 mt-2">
                                        {video.photoUrl && (
                                            <img src={video.photoUrl} alt="avatar" className="avatarc rounded-circle" width="30" height="30" />
                                        )}
                                        <span className="pl-1 pr-1">{video.name}</span>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-group">
                                        <label htmlFor="country" className="control-label col-form-label"><span className="text-danger ml-1">*</span>{ar.country}</label>
                                        <input type="text" ref={e => this.country = e} defaultValue={video.country} className="form-control" id="country" maxLength="60" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="age" className="control-label col-form-label"><span className="text-danger ml-1">*</span>{ar.age}</label>
                                        <input type="text" ref={e => this.age = e} defaultValue={video.age} className="form-control" id="age" maxLength="60" />
                                    </div>
                                    <div className="form-group mt-4">
                                        <input type="checkbox" ref={e => this.featured = e} defaultChecked={video.featured} onClick={this.onCheck.bind(this,'featured')} className="custom-control-input" id="v-featured" name="radio-featured"/>
                                        <label className="custom-control-label" htmlFor="v-featured"><span className="pr-4">{ar.mark_as_featured}</span></label>
                                    </div>
                                    <div className="form-group mt-4">
                                        <input type="checkbox" ref={e => this.reviewed = e} defaultChecked={video.reviewed} onClick={this.onCheck.bind(this,'reviewed')} className="custom-control-input" id="v-reviewed" name="radio-reviewed"/>
                                        <label className="custom-control-label" htmlFor="v-reviewed"><span className="pr-4">{ar.mark_as_reviewed}</span></label>
                                    </div>
                                    <div className="button-group mt-3">
                                        <button type="button" className="btn waves-effect waves-light btn-rounded btn-info" onClick={this.updateVideoDetails}>{ar.save}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <Player poster={video.poster} src={video.url} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card no-toolbar border-0 mb-0">
                                <div className="card-body pl-0 pr-0">
                                    <div className="row">
                                        <div className="col-12 mt-2">
                                            <h4 className="card-title">
                                                {ar.comments}
                                            </h4>
                                            <h5 className="card-subtitle">{ar.total} {video.comments}</h5>
                                        </div>
                                    </div>
                                    <table id="sawtable" className="mt-3 tablesaw table-bordered table-striped table-hover table no-wrap"
                                        data-tablesaw-mode="swipe">
                                        <thead>
                                            <tr>
                                                <th scope="col" data-tablesaw-sortable-col
                                                    data-tablesaw-priority="2"
                                                    className="border">&nbsp;</th>
                                                <th scope="col" data-tablesaw-sortable-col data-tablesaw-priority="3"
                                                    className="border">{ar.name}
                                                </th>
                                                <th scope="col" data-tablesaw-sortable-col data-tablesaw-priority="4"
                                                    className="border">{ar.comments}
                                                </th>
                                                <th scope="col" className="border">
                                                    {ar.delete}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {comments.map((comment,index) => this.renderComment(comment))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Loading show={loading} />
            </div>
        );
    }
};
